const INCOME_SUMMARY_ORDER = [
  "Employee Business Expenses",
  "Positive Net Rental Real Estate",
  "Sole Proprietorship",
  "Partnership",
  "S Corporation (S-Corp)",
  "Regular Corporation (C-Corp)",
  "Retirement - Tax Returns",
  "Retirement - Other",
  "Alimony - Tax Returns",
  "Alimony - Other",
  "Child Support",
  "Trust",
  "Interest",
  "Royalty",
  "Farming",
  "Capital Gains",
  "Installment Sale",
  "Other",
];

export default INCOME_SUMMARY_ORDER;
